import * as React from 'react';
import FormSelect, {FormSelectProps} from 'cl-form/FormSelect/index';
import {getAllAmazonSitesForOptions} from '../../../../MyAccount/AmazonListings/amazonListingHelpers';
import {useSelector} from 'react-redux';
import {StoreState} from '../../../../App/initialStore';

export const INITIAL_AMAZON_SITE = 'ATVPDKIKX0DER';

export interface AmazonSitesSelectProps extends FormSelectProps {}

const AmazonSitesSelect: React.FunctionComponent<AmazonSitesSelectProps> = ({options, ...props}) => {
  const allOptions = useSelector(getAllAmazonSitesForOptions);
  return <FormSelect options={options ? options : allOptions} {...props} />;
};

export default AmazonSitesSelect;
